export default {
    ok: "Ok",
    no: "No",
    download: "Download",
    continue: "Continue",
    resume: "Resume",
    changeLang: "Change languages",
    players: "players",
    add: "Add",
    lesgo: "Let's go!",
    objectiveUpdated: "Objective updated",
    objectives: "Objectives",
    objective: "Objective",
    sounds: "Sounds",
    music: "Music",
    volume: "Volume",
    quitStory: "Quit",
    enterPlayerName: "Enter another player's name or their player #Code",
    deleteStory: "Delete story",
    choose: "Choose",
    newState: "New state",
    storyVersion: "Story version",
    downloading: "Downloading...",
    language: "Language",
    options: "Settings",
    about: "About",
    legalMentions: "Legal information",
    confidentiality: "Privacy",
    ourSocials: "Socials",
    rateUs: "Rate us",
    credits: "Credits",
    discordSub: "Join our brilliant community",
    instagramSub: "Follow our incredible posts",
    twitterSub: "Get the latest updates",
    fbSub: "Drop us a Like or two",
    ytSub: "Follow our vlogs",
    team: "The team",
    thankss: "Special thanks",
    collab: "With help from",
    news: "News",
    newsSubtitle: "Get all our latest news",
    stories: "Stories",
    decisive: "Decisive choices",
    change: "Changes",
    secret: "Secret sequence",
    secretTextHide: "This sequence doesn't concern you",
    legalUrl: "https://talesup.io/legal/en",
    cguvUrl: "https://talesup.io/cguv/en",
    confiUrl: "https://talesup.io/politique/en",
    discoverStories: "Discover stories",
    welcome: "Welcome!",
    welcomeToTalesUp: "Welcome to Tales Up !",
    welcomePartOne:
        "This is Tales Up, a little app made with a lot of love, where you'll find several stories to play with your friends.",
    welcomePartTwo: "We hope you enjoy your time here!",
    welcomePartThree: "- The team",
    thankYouText:
        "Follow us to get the latest news and updates!\n\nWe would also love to have your feedback about the app! 🔥",
    thankYouTitle: "Thank you for playing this story!",
    laterPromise: "Later, promise",
    signIn: "Login",
    signUp: "Sign up",
    forgotPassword: "I forgot my password",
    register: "Register",
    closedBeta: "Closed Beta",
    closedBetaSub: "Welcome to the closed beta of Tales Up.",
    closedBetaSub2:
        "All your progress on this version is temporary and will not be retained or reflected on the official version, either on the existing mobile application or on the future public browser version.",
    closedBetaSub3: "Enter the beta access code you received to continue.",
    registerWithEmail: "Register via email",
    newsletterRegister:
        "I would like to receive the Tales Up newsletter, no spam, we promise 🙃",
    required: "required",
    resetPassword: "Reset your password",
    resetPasswordIntro1: "Sorry 😞, there's nothing we can do!",
    resetPasswordIntro2:
        "No, wait, just kidding, enter your email address below and we'll send you a link to reset your password.",
    resetEmailSent: "We sent you an email with a link to reset your password",
    shop: "Shop",
    shopSubtitleStory: "Stories & Series",
    shopSubtitleAvatar: "Avatars & Cosmetics",
    shopSubtitleFeatured: "Featured",
    shopSubtitleFeatured2:
        "Personalized offers just for you, gifts every week and the latest news and releases.",
    shopSubtitleTickets:
        "Purchase our amazing Adventurer Pass or tickets for stories, offers, cosmetics and avatars.",
    shopSubtitleTickets2:
        "You can also go to the mobile app if you want to pay in other currencies or with another payment method",
    shopSubtitleTickets3: "Tickets are only available for purchase",
    shopSubtitleTicketsUnavailable:
        "Unavailable at the moment 🤙 (in the meantime, you can still buy tickets via the Tales Up app, available on iOS and Android).",
    currencies: "Currencies",
    library: "Adventures",
    storyShop: "Buy stories",
    errorNoTrad: "Unavailable in your language",
    alreadyExists: "You already own this story",
    alreadyExistsTitle: "You already own this",
    notEnougthTickets: "Oops, it looks like you don't have enough tickets!",
    notEnoughTokens: "Oops, it looks like you don't have enough tokens",
    notEnougthTicketsTitle: "Not enougth tickets",
    serverUnderMaintenance: "Maintenance in progress",
    maintenancePartOne:
        "The servers are currently down for maintenance, please check our twitter for additional information",
    checkTwitter: "Check Twitter",
    newVersionAvailable: "New version available",
    updateVersion: "Update Tales Up",
    updatePartOne:
        "A new version of Tales Up is available in stores, please update to the latest version before you continue playing",
    saves: "Saves",
    cancel: "Cancel",
    deleteSaveTitle: "Warning",
    deleteSaveMsg:
        "You are about to delete this save. This action is final and cannot be reversed. Are you sure you want to delete this save forever?",
    selectSaveToLoad: "Choose a save from the previous chapter to continue",
    seeAchievement: "See achievements",
    playerUnlockedThis: "Players unlocked this",
    achievementsCompleted: "Achievement unlocked",
    achievementCompleted: "Achievement unlocked",
    achievementsCompletedMaj: "Achievement unlocked",
    achievements: "Achievement",
    storiesOwned: "stories owned",
    episode: "Chapter",
    episodes: "Chapters",
    Episodes: "Chapters",
    getAllEpisodes: "Get all chapters",
    enterEpOne: "Enter chap. 1",
    buyEpisode: "Buy this amazing chapter?",
    howToBuyEpisode: "How do you wanna buy this amazing chapter?",
    greatChoice: "Great choice! We just added this story to your library.",
    greatChoicePack: "Great choice! All items have been added to your library.",
    cantBuyPack:
        "You can't buy this pack. You already own it or some of the items it contains.",
    goCheck: "Go check",
    greatChoiceItem: "Great choice! We've added this item to your collection.",
    greatChoiceSlot: "Great choice! We've added this slot to your account",
    yeahIKnow: "I know!",
    switchAccount: "Switch accounts",
    createAccount:
        "Create an account to see our stories and save your progress",
    alreadyOnTalesUp: "Already have an account? ",
    login: "Login",
    signInSubtitle: "Login to your Tales Up account",
    confirmed: "Activate",
    confirmedForgot: "Confirm!",
    buyStory: "Buy this amazing story?",
    howToBuyStory: "How would you like to buy this amazing story?",
    buyAllEpisode: "Buy this amazing series?",
    sureToExit: "Are you sure you want to leave now?",
    looseAchievements:
        "You will lose any achievements unlocked during this session",
    exit: "Exit",
    back: "Cancel",
    newPseudo: "New username",
    update: "Save",
    titlesUnlocked: "Titles unlocked",
    registerSubtitle:
        "Create an account to see our stories and save your progress!",
    registerConfirmedSubtitle:
        'Your account has been created! You can now log in by pressing the "Login" button below.',
    registerConfirmedSubtitleBis:
        "Your account has been created! You can now log in using these credentials.",
    registerConfirmedSubtitle2:
        "We wish you lots of exciting adventures on Tales Up!",
    activationEmailSent:
        "An activation email has been sent to the address you gave",
    activationEmailSent2:
        "Please activate your account before logging in to Tales Up",
    activationEmailSent3:
        "It may take a few minutes to arrive, consider checking your spam and if it's not there either, use the 'I didn't receive the email' button",
    done: "Done!",
    error: "Error",
    understood: "understood!",
    deleteSave: "Delete",
    delete: "Delete",
    keepIt: "Keep",
    allSaves: "Your adventures are saved here",
    savesUsed: "Saves used",
    replace: "Replace",
    confirm: "Confirm",
    selectSlot: "Select an empty save slot or replace an existing one",
    replaceSaveMsg:
        "You are about to overwrite this save. This action is final and cannot be undone. Are you sure you want to replace this save?",
    great: "Great!",
    noSaveToLoad:
        "Oops, it looks like you don’t have any saves from the previous chapter",
    logout: "Log out",
    support: "Support",
    upgrade: "Update",
    contactSupportDescription:
        "If you are encountering an issue with the app that is not listed here, please send us a detailed report using the button down below. Our support team will get back to you as fast as possible!",
    contactUs: "Contact us",
    tickets: "Tickets",
    tokens: "Tokens",
    title: "Title",
    titlesList: "Titles",
    rewardReceived: "Congratulations! You received a new reward",
    achievementLocked: "Achievement locked",
    buyItem: "Do you want to buy this amazing item?",
    item: "Item",
    password: "Password",
    passwordLost: "I forgot my password",
    rescueMe: "Save me!",
    achievementsUnlocked: "Achievement unlocked",
    noTradsAvailable: "of your stories are not available in this language yet",
    noTradAvailable: "of your stories are not available in this language yet",
    welcomeAboard: "Welcome to Tales Up!",
    welcomeAboardSub:
        "Here you can have epic adventures with your buddies but beware, every choice has consequences.... \n(Click to confirm, click again before the end to cancel)",
    welcomeAboard2: "Beware of consequences...",
    welcomeAboard2Sub1:
        "Ah, a bit of a suck-up around the edges then.... I like it! For your trouble I offered you the first episodes of each series and saga. It's good because it's you!",
    welcomeAboard2Sub2:
        "Ah, a bit of a dunce then... I like it! For your trouble, I've given you the first episodes of every series and saga. It's good because it's you!",
    welcomeChoice1: "So cool! Thank you",
    welcomeChoice2: "Ah... Is that all?",
    welcomeAboard3: "Quality and honesty",
    welcomeAboard3Sub:
        "Yep, no ads or other dubious models here. If you want to enjoy the full adventures, you'll have to buy them or get our super pass. However, if you own an adventure, your friends can play it for free with you!",
    welcomeAboard4: "All of your stories, all in one place!",
    welcomeAboard4Sub: "Choose one and begin your adventure!",
    iGetItMaster: "I'll be careful master ✌️",
    letMePlayNow: "Who do you think I am? ☠️️",
    titleReceived: "You unlocked a new title!",
    discoverLibrary: "Discover adventures and happiness as well 🔥",
    notNow: "Later",
    hellYes: "Yes!",
    getTickets: "Buy tickets",
    seeMyItems: "Change appearance",
    avatar: "Avatar",
    emailRequired: "You must enter your email address",
    emailInvalid: "This email address is invalid",
    passwordRequired: "You must enter your password",
    passwordInvalid: "This password is invalid",
    pseudoRequired: "You must enter your username",
    pseudoInvalid: "This username is invalid",
    passwordStrength:
        "Your password must include at least 8 caractères, one capital letter, a number and a special character.",
    changePseudo: "Change username",
    changeTitle: "Change title",
    goToShop: "This way!",
    slotAvailable: "Empty slot",
    joinGame: "Join a game",
    jumpFriend: "Dive into a friend's adventure",
    writing: "Writing",
    art: "Art",
    sound: "Sounds",
    playerDidThis: "Players did this",
    popupSave:
        "It looks like all of your save slots are full. If you want to save, please choose a slot to replace.",
    popupSaveDone:
        "A save of the chapter was created automatically. Would you like to keep playing?",
    dontSave: "Don't save",
    createSave: "Create a save",
    saveSuccessful: "Your progress has been saved!",
    agreeTerms: "I accept the ",
    agreeTerm: "I accept the ",
    terms: "terms and conditions",
    privacyPolicy: "Privacy policy",
    Terms: "Terms and conditions",
    introTerms:
        "By using this application, you agree that you have read the terms and conditions and will follow them at all times.",
    join: "Join",
    codeRequired: "You must enter the code",
    code6Characters: "The code must be 6 characters long",
    progress: "Progress",
    social: "Ambassador",
    success: "Success",
    missionDone: "Completed",
    noNewItemAvailable: "There are no more items available in this category!",
    noNewTicketsAvailable:
        "It looks like tickets are not available for purchase in your country or on your device. 🙃",
    noNewStoryAvailable:
        "It looks like you have all the stories already! Thank you!☺️ Don;t worry though, we try to publish more regularly 🙃",
    featured: "Featured",
    incomingStory: "Coming soon",
    enter: "Enter",
    promo: "Promo",
    enjoyYourNewTickets: "Thank you for your purchase! Enjoy your tickets!",
    enjoyYourNewTicketsAds: "Enjoy your tickets!",
    goShopping: "Go shopping",
    logoutMsg: "Are you sure you want to log out?",
    logMeOut: "Yes!",
    logedInAs: "Logged in as",
    activateSound:
        "For an optimal group experience, read the story out loud, and raise the volume!",
    activateSoundIOS:
        "For an optimal group experience, read the story out loud, turn silent mode off, and raise the volume!",
    okay: "Okay",
    onlineRoom: "Online",
    availableSoon: "(unavailable)",
    onlineRoomSub: "Play with friends around the world",
    boardGameRoom: "Local / Solo",
    soloRoom: "Solo mode",
    playerCode: "#playercode",
    resetLang:
        "The language has been changed, press Okay to restart the app so that the change is taken into account",
    emailResent:
        "We've resent you an activation email (it may also take a few moments to arrive)",
    sent: "Sent",
    boardRoom: {
        title: "Tabletop / Solo mode",
        subtitle: ", Play with friends or companions around this device",
        enterName: "Enter the players’ names",
        enterCode: "Enter their ",
        underPseudo: "(Visible under the name in the sidebar)",
        tip: "Astuce : Adding a player via their ",
        tipEnd: " allows them to also unlock achievements for this story!",
    },
    code: "code",
    onlineRoomModal: {
        title: "Online mode",
        subtitle:
            ", Each player on their own device, and you all vote for choices.",
        sendThe: "Send the room",
        ofGame: "to your friend",
        button: "(The ‘Join a game’ button can be found in the “My stories” tab!)",
        ownStory:
            "2. Your friends do not need to own the story to join your game!",
        tip: "No friends available? Come make some in our ",
        discord: "discord",
        tipEnd: " server! 😉",
    },
    boardGameRoomSub: "Play with friends or companions around this device",
    soloRoomSub: "Perfect for exploring stories at your own pace",
    copied: "Copied",
    missionRewardPopup: "Complete quests to unlock this item!",
    playerNotFound:
        "We couldn't find the player, are you sure the code you entered is correct? Codes are displayed on the My stories page, under the title and preceded by a #",
    playerAlreadyExists: "That player is already on your list!",
    stillNotReceived: "I haven't received the email",
    missionText: "Complete story quests to unlock this item",
    errorGoogle:
        "An error has occurred, please try again. If the error persists, please contact us at the following address: support@talesup.io.",
    errorGooglePwd:
        "That account was created via Google, please login using the 'Continue with Google' button",
    errorFbPwd:
        "That account was created via Facebook, please login using the 'Continue with Facebook' button",
    errorApplePwd:
        "That account was created via Apple, please login using the 'Continue with Apple' button",
    continueWithGoogle: "Continue with Google",
    continueWithFacebook: "Continue with Facebook",
    continueWithApple: "Continue with Apple",
    or: " OR ",
    orContinueWith: " Or continue with ",
    pleaseDontLeave:
        "Thank you! We are confirming your purchase! Please don’t close the app, this won't take long 🔥",
    verifyingOrder: "Verifying",
    purchaseCanceledOrRefusedPayment:
        "You cancelled your purchase or your payment method was refused",
    anErrorOccured: "An error has occured",
    purchasePending: "Purchase pending",
    purchasePendingSub:
        "Thank you, your purchase is pending, once payment has been verified, you will receive your tickets. If your payment is refused, nothing will happen. You can close this window, another will open once your purchase is confirmed.",
    level: "Level",
    congrats: "Congratulations! 🥳",
    levelUp: "You have reached level ",
    information: "Information",
    seriesDecoupage:
        "This story was available in the demo. It has since been divided into several chapters. The chapters are therefore not a continuation of the story in the demo.",
    show: "Display",
    readMore: "See more",
    readLess: "See less",
    notUnlocked: "Not unlocked",
    notUnlockedSub: "???",
    showMe: "Show me",
    missingEpisodes:
        "You don't have all of the necessary chapters to complete this quest. You will be able to complete it and receive rewards once you own them all ! 🔥",
    cookies: "Cookies",
    manageChoices: "Manage my choices",
    goBack: "Back",
    goBackToLibrary: "Go back to the Library?",
    confirmGoBack:
        "Are you sure you want to leave ? You will lose any achievements unlocked during this session",
    acceptTerms:
        "Please agree to the terms and conditions to complete the signup process",
    acceptTermsMandatory: "You must agree to the terms and conditions",
    acceptRgpdMandatory: "You must agree to the privacy policy",
    promoCode: "Enter a code",
    addedToLibrary: "Your rewards have been added to your account",
    articles: "Articles",
    contact: {
        issue: " : Tales Up issue",
        infos: "User info: (do not delete) %0Aid : ",
        problem:
            "%0A%0AYour problem (please share any information that you consider useful) : %0A",
    },
    playersConcerned: "Concerned players",
    playerConcerned: "Concerned player",
    backToGroup: "Back to the group",
    nowReady: "is ready to be played",
    promoErrors: {
        promoAlreadyUsed: "You have already used that code",
        promoSoldOut:
            "The maximum number of uses for this code has already been reached",
        promoNotExist: "That code does not exist",
        promoNotActive: "That code is no longer available",
        promoNotValid: "That code is invalid",
    },
    deleteAccount: "Delete my account",
    deleteAccountInfo:
        "By confirming, you will begin the deletion process for your account, which cannot be reversed. This action is final and there is no going back. Are you sure you want to delete his account?",
    deleteAccountConfirm:
        "We're sad to see you go 😔 Do you confirm that you want to delete your account? We will send you an email once the process is complete.",
    deleteAccountError:
        "An error has occurred while deleting your account, please contact us by using the ‘Contact us’ option from the ‘Assistance’ menu on the previous page",
    end: "End!",
    youCan: "you can",
    in: "In",
    playYourStories: "play your stories and series",
    consultProgress: "check on your progress, your quests, and claim rewards",
    customizeAvatar: "edit your avatar and change your title",
    next: "Next",
    weve: "We have",
    offered: "gifted you",
    theseStories: "these stories",
    weveOfferedYouStories: "We have gifted you these stories!",
    complete: "Full stories",
    asWellAs: "As well as",
    firstEp: "1st chapter",
    of: "of",
    packs: "Bundle",
    seeMore: "See more",
    owned: "Owned",
    buyPack: "Do you want to buy this bundle?",
    mypseudo: "username",
    pseudo: "Username",
    mypassword: "mypassword",
    notAvailable: "Unavailable in this language",
    remark: "remark",
    value: "value",
    alreadyClaimed:
        "You have already collected the reward for this mission (it may take a few moments to display)",
    ftueFeatured: {
        discover:
            "Find out about our latest releases (stories, series, avatars...)",
        promo: "Make the most of our weekly sales",
        news: "Read our latest news (team, project...)",
    },
    ftueShop: {
        story: "Unlock stories and series",
        item: "Unlock new items and avatars",
        ticket: "Purchase some tickets",
        packs: "Unlock bundles",
    },
    ftueQuest: {
        level: "Follow your level and quest progress",
        item: "Unlock unique items and avatars",
        ticket: "Get tokens",
        title: "Claim titles exclusive to certain stories or series",
    },
    new: "New",
    le: "the",
    la: "the",
    les: "the",
    secretSequence: {
        choiceToTell: "Keep the following information to yourself",
    },
    ftueSolo: {
        sub: "you make choices for yourself and for your team",
        soloWarning: "Some features are not designed for singleplayer",
        loline: "Loline",
        lolineSub:
            "she is a wild and feisty adventurer. She is afraid of nothing and no-one",
        alphonse: "Alphonse",
        alphonseSub:
            "he can seem cold and rough at first. But no one could ask for a more loyal companion",
        eugenie: "Eugenie",
        eugenieSub:
            "discrete and unassuming. Behind her timid ways, she is a peerless tactician",
    },
    endGame: {
        title: "What next?",
        recommand: "Recommandations",
        stories: "Your stories",
        back: "Back to menu",
    },
    levels: {
        title: "Levels",
        sub: "Level up by completing quests and collect rewards",
        gotReward: "You can collect new level rewards",
        disciple: "Disciple",
        prodigy: "Prodigy",
        master: "Master",
        legend: "Legend",
    },
    quests: {
        quests: "Quests",
        weekly: "Weekly",
        questsCompleted: "Completed quests",
        questsSubtitle: "Complete quests to get rewards and level up!",
    },
    ads: {
        watch: "Watch ads to earn some tokens",
        congrats: "Thank you! Enjoy your tokens!",
    },
    consent: {
        needConsentTitle: "We need your consent",
        needConsentSub:
            'Ads are optional but if you wish to see them, we need your consent.\n\nPlease change your preferences by clicking the "Change my preferences" button below then "Allow"',
        needConsentSubIOSUnder14:
            'Ads are optional but if you wish to see them, we need your consent.\n\nPlease change your preferences by clicking the "Change my preferences" button below and then going to Settings > Privacy > Advertising > Disable "Limit Ad Tracking"',
        noAdsToShowTitle: "It seems we don't have any video to show you 😢",
        noAdsToShowAndroid:
            'Your tracking preferences could block or restrict the number of ads you can see, we invite you to check your preferences by clicking the "Change my preferences" button below and then "Allow".\n\nIf you\'ve already agreed, please try again later.',
        noAdsToShowIOSOk: "Please try again later",
        noAdsToShowIOSNotOk:
            'Your tracking preferences could block or restrict the number of ads you can see, please check your preferences by clicking the "Change my preferences" button below and then "Allow tracking".\n\nIf you\'ve already agreed, please try again later',
        noAdsToShowIOSNotOkUnder14:
            'Your tracking preferences could block or restrict the number of ads you can see, so we invite you to try again later or to check your preferences by clicking the "Change my preferences" button below and then going to Settings > Privacy > Advertising > Disable "limited ad tracking"',
        manageOptions: "Update preferences",
        preferencesUpdated: "Preferences updated",
    },
    purchase: {
        title: "Payment",
        validate: "Payment validated",
        validateSub:
            "Thank you very much! Your purchase was successful, you should have received your tickets or your pass in a few seconds as well as an email receipt. Enjoy!",
        validationError: "Validation error",
        paymentError: "Payment error",
        paymentErrorSub: "Transaction failed, an error has occurred:",
        backToStore: "Go back to store",
    },
    // Purchase errors
    purchaseErrors: {
        receiptErrorIOS:
            "It would appear that Apple blocked your transaction, this can occur if your IPhone is ‘jailbroken’ or if Apple's servers or our own are temporarily closed. Because the transaction was not completed, we will make another attempt to verify it. If the issue persists, please contact us using the ‘Assistance’ option in the Menu.",
        receiptErrorAndroid:
            "It would appear that Google blocked your transaction, this can occur if your phone is ‘jailbroken’ or if Google's servers or our own are temporarily closed. Because the transaction was not completed, we will make another attempt to verify it. If the issue persists, please contact us using the ‘Assistance’ option in the Menu.",
        purchaseGlobalError:
            "An error has occurred with your transaction. Because the transaction was not completed, we will make another attempt to verify it. If the issue persists, please contact us using the ‘Assistance’ option in the Menu.",
        errorCode: "Error code : ",
        err01: "We were unable to complete the transaction. Code: ERR-01",
        err02: "We were unable to complete the transaction. Code: ERR-02",
        err03: "We were unable to complete the transaction. Unable to validate a previously failed purchase. Code: ERR-03",
        err04: "We were unable to complete the transaction. The account that made this purchase is different from the one you are logged in with. Code: ERR-04",
        err05: "We were unable to complete the transaction. It appears that the information is invalid. Code: ERR-05",
        err06: 'We were unable to complete the transaction. It appears you are not logged in, please try refreshing the page and logging in again, or press "Need help". Code: ERR-06',
        err07: 'We were unable to complete the transaction. Try refreshing the page and logging in again, or press "Need help". Code: ERR-07',
        err08: "The transaction has been cancelled. Code: ERR-08",
    },

    // ----
    actions: {
        cancel: "Cancel",
        gotIt: "I understand",
        invitePlayers: "Invite",
        leave: "Leave",
        leaveGame: "Leave the game",
        startGame: "Start",
        sure: "Quit?",
        remove: "Remove?",
        yes: "Yes",
        resume: "Resume",
        skip: "Skip",
        send: "Send",
        enterMessage: "Enter your message",
        roll: "Roll",
        addPlayer: "Add Player",
        accept: "Accept",
        decline: "Decline",
        collect: "Collect",
    },
    errors: {
        invalidCode: "This code is invalid",
        gameAlreadyStarted: "This game is already in progress",
        hasReachedPlayerMaxLimit: "This lobby is already full",
        noGameExists: "This lobby doesn't exist",
        playerNotInSave:
            "You are not on the list of saved players from the previous chapter",
        notSameLanguage:
            "This game is not in your language, please change to be able to join it",
        errorOccured:
            "An error has occurred, please restart the application and try again",
        notEnoughTickets: "Oops, it looks like you don't have enough tickets!",
        notEnoughSlots:
            "Oopsn it looks like you don't have enough slots available",
        cantAddYourself: "You can't add yourself to friends",
        notLoggedIn: "You don't seems logged in, please refresh the page",
    },
    labels: {
        gameID: "Code",
        gameStopped: "The game was stopped",
        player: "Player",
        players: "Players",
        remember: "Remember",
        waitingFor: "Waiting for",
        waiting: "Waiting..",
        you: "You",
        info: "Information",
        enterAnswer: "Enter your answer:",
        gameOver: "Game Over",
        resume: "Resume the game?",
        rewards: "Rewards",
        needHelp: "Need help?",
        availableNow: "Available Now",
        experience: "Experience",
        rollDice: "Rolling dice",
        youGotA: "You got a",
        getMoreThan: "Get more than",
        toSucceed: "to succeed in this action",
        random: "Random",
        success: "Success",
        failure: "Failure",
        addPlayerSubtitle: "Add someone playing around this device",
        yourPlayerCode: "Your player code : ",
        guest: "Guest",
        soloOnly: "This story can only be played solo",
    },
    messages: {
        alreadyVoted: "You already voted",
        enterGameID: "Please enter the game code",
        hasLeftOnlineGameMessage: "You left the game!",
        leavingGameForHost:
            "Leaving the game as the host will end the game for everyone!",
        leavingGameForPlayer:
            "Leaving the game will harm the other players' experience!",
        notConcerned: "It's not your turn to vote",
        removePlayerForGame: "Remove this player?",
        shareGameID:
            "Share this code with other players so that they can join your game!",
        storyDownload: "Downloading story...",
        waiting:
            "Some players aren't ready yet... \n\n This popup is displayed if one or more players have not yet changed scene. This may take longer on some devices or depending on their connection. In addition, please ensure that all players remain on the app and that their phones don't lock).",
        waitingHost: "Waiting for the host...",
        waitingPlayers: "Waiting for all players to be there...",
        sound: "For more immersion, we recommend using sounds.",
        bug: "Switching scene may take longer from one device to another or depending on the connection. Make sure all players stay on the game, especially the game host. A chat is available by pressing the button in the top right-hand corner.",
        bugLoading:
            "The loading seems abnormally long, do you want to try to resynchronize?",
        anErrorOccuredOfferReward:
            "An error has occurred, the offer may no longer be available or you have already retrieved it.",
        gameOver:
            "You can try your luck again. You will now be redirected to the main menu",
        resumeGame: "Do you want to resume the current online game?",
        whereFrom: "Where's this image from ?",
        redirectToPayment:
            "You are about to be redirected to the payment page, do you want to continue?",
        changeCurrency:
            "(If you wish to change the currency used for payments, please go to shop)",
        appNotInstalled:
            "It seems that the Tales Up application is not installed on your device. You can install Tales Up via App Store or Google Play Store.",
        diceRolled: "The dice of fate have decided for you",
    },
    titles: {
        lobby: "Lobby",
        social: "Social",
    },
    socials: {
        discord: "https://discord.gg/HS44T3NJHm",
        insta: "https://www.instagram.com/tales.up.en/",
        twitter: "https://twitter.com/tales_up_en",
        facebook: "https://www.facebook.com/Tales-Up-105620054346366",
        youtube: "https://www.youtube.com/channel/UC7QoABiwjVcdRGBVZ5gADyw",
    },
    time: {
        d: "d:",
        h: "h:",
        min: "min",
        m: "m",
        s: "s",
        days: "Days",
        hours: "Hrs",
        Min: "Min",
        sec: "Sec",
    },
    currency: {
        eur: "EUR",
        usd: "USD",
    },
    featuredGroup: {
        yourGift: "Here is your gift of the week! Enjoy it! 🎉",
        freeAvatar: "+1 Avatar",
        freeGift: "1 Free gift",
    },
    series: "Series",
    seriess: "Series",
    saga: "Saga",
    adventures: "Adventures",
    comingSoon: "Coming soon",
    board: {
        hint: "Hint",
        objective: "Objective",
        secret: "Secret",
        object: "States & Items",
        adventure: "Adventure",
        univers: "Univers",
    },
    topMenu: {
        logbook: "Logbook",
        information: "Informations",
        teamObject: "Team Object",
        hint: "Hint",
        newHint: "A new hint has been added to your logbook",
        groupObject: "Group inventory",
        chat: "Chat",
    },
    urls: {
        apple: "https://apps.apple.com/en/app/tales-up/id1533630240",
        beta: "https://beta.talesup.io",
        cguv: "https://talesup.io/cguv/en",
        contactUs: "mailto:contact@talesup.io",
        discord: "https://discord.gg/yeJ7UsWGY4",
        google: "https://play.google.com/store/apps/details?id=com.talesupreader&hl=en",
        legal: "https://talesup.io/legal/en",
        play: "https://play.talesup.io",
        app: "talesup://",
        privacy: "https://talesup.io/politique/en",
        socials: "https://linktr.ee/talesup",
    },
    pass: {
        getThe: "Get the",
        adventurerPass: "Adventurer Pass",
        adventurerPassPlus: "Adventurer Pass +",
        active: "Active",
        passActive: "Pass Active",
        pass: "Pass",
        unlock: "Unlock",
        whatsInside: "What's inside?",
        yourAdvantages: "Here's what you get:",
        annualPass: "Annual Pass",
        lifetimePass: "Lifetime Pass",
        unlimitedDuration: "Unlimited duration",
        yearPass: "1 year Pass",
        fullAccess: "Full Access",
        noSub: "No subscription",
        getItNow: "Get it Now ✨",
        allStories: "Lifetime access to all adventures",
        avatar: "An exclusive avatar",
        future: "Access to any future story as soon as it's released",
        title: "An exclusive title for your character",
        saves: "20 extra save slots",
        reloadPage: "You may need to reload the page",
        valid: "Valid.",
        for: "For.",
        life: "Life.",
        from: "Starting from",
        choosePass: "Select your pass",
        allAvatars: "All premium avatars",
        allCosmetics: "All premium cosmetics",
        allCompanionSlots: "All companion slots",
        value4: "4x Value",
        value5: "5x Value",
        enjoyYourNewPass:
            "Thank you for your purchase! Enjoy your new Adventurer's Pass and all its benefits!",
    },
    companions: {
        companion: " Companion ",
        companions: "Companions",
        addCompanion: "Add Companion",
        addCompanionSubtitle: "A virtual companion from your list",
        selectedCompanions: "selected companion.s",
        cantEquip: "Pre-made characters cannot equip cosmetics",
        buySlot: "Purchase a companion slot?",
        buySlot1: "Buy companion slot",
        whatToAdd: "Choose what to add",
    },
    friends: {
        friends: "Friends",
        friend: "Friend",
        subtitle:
            "Add friends to track their progress and invite them to play with you",
        requests: "Requests",
        invites: "Invitations sent",
        inviteSent: "Friend request sent",
        addFriend: "Add friend",
        request: "Friend request",
        invitedYou: " invited you to be ",
        friendsMin: "friends",
        removeFriend: "Would you like to remove ",
        fromYourList: " from your friends list?",
        invalidCode: "This player code is invalid or doesn't exist",
        addFriendText: "Enter a friend’s ",
        playerCode: "#playercode",
        selectedFriends: "selected friends",
    },
    ladder: {
        ladder: "Leaderboard",
        subtitle:
            "Complete quests, gain experience, level up and earn your place in the leaderboard!",
        yourPosition: "Your position: ",
    },
    online: {
        online: "Online games",
        subtitle:
            "No one to play with? You've come to the right place! Join public games and go on adventures!",
        publicGames: "Public games",
        mostRecent: "Most recent",
        lessRecent: "Less recent",
        byStory: "By story",
        refresh: "Refresh list",
        noGames: "No games available for the moment",
        invitedYou: " invited you to play",
        invites: "Invitation",
        invitationsSent: "Invitation(s) sent",
        invitationDeclined: "An invitation was declined",
        public: "Public",
        switchingTo: "By switching to ",
        publicMode: "public mode",
        privateMode: "private mode",
        switchPublicText: ", your lobby will be open to everyone!",
        switchPrivateText: ", your lobby will no longer be open to everyone.",
        inviteRequiredPlayers: "Invite required players",
        fromSave: "from the save",
        wannaJoin: "Do you want to join ",
        wannaJoin2: "'s adventure ",
    },
    user: {
        finalizeRegister: "Finalize your registration",
        finalizeRegisterSubtitle:
            "You currently have a guest account. This temporary account is valid for 30 days and only allows you to play the adventures. To access the various features of the application, keep your progress and be able to reconnect from anywhere, finalize your registration!",
        finalizeWithEmail: "Finalize via email",
        errorNoGuestFound:
            "We couldn't find your guest account, please refresh the page",
        everythingReady: "Everything is ready!",
    },
    ftue: {
        startAdventure: "Start the adventure 🔥",
        alreadyHaveAccount: "I already have an account 👍",
        doItLater: "I'll do it later",
        screen1Title: "First time here or already registered?",
        screen1Subtitle:
            "Start the Tales Up adventure now or log in to continue!",
        screen2Title: "Welcome to Tales Up!",
        screen2Subtitle:
            "You'll need an account, but for now you can simply enter a nickname and finalize your registration later.",
        screen3Title: "One last thing",
        screen3Subtitle:
            "Here, you can have epic adventures with your buddies, but beware, every choice has consequences...",
        screen4Title: "Ready for adventure",
        screen4Subtitle:
            "To get you started on the Tales Up adventure, let's discover the app!",
        storyTitle: "The Gallery",
        registerNow: "I'd rather register now",
        game: {
            title: "Local / Solo Mode",
            intro: "In ",
            intro2: ", play only on this device.",
            names: "1. write the names of people around you or add their ",
            names2: "#playercode",
            names3: " if they have a Tales Up account",
            companions:
                "2. Add your companions to complete the team and make decisions for them",
            solo: "3. if you want to play solo, add only your companions to the group",
        },
        library: {
            intro: "“Let me guide you a little. From here, you can set off to discover the many adventures told in my paintings.“",
            footer: "The first episodes of the series are available free of charge.",
            stories: "1. play and replay your stories and series",
            avatar: "2. personalize your avatar and change your title",
            companions: "3. manage your companions",
        },
        online: {
            title: "Online mode",
            intro: "In the ",
            intro2: ", everyone plays on their own device and votes for their choices.",
            code: "1. send the code to other players so they can join",
            friends: "2. invite your friends directly",
            public: "3. activate the “Public“ option to allow other unknown players to join the adventure",
        },
        shop: {
            title: "Shop",
            intro1: "You can buy individual adventures with our ",
            intro2: " or opt for the ",
            intro3: " offering full access.",
            intro4: "If you own an adventure, your friends can play it with you locally or online at no extra cost",
            footer: "Our business model is fair and honest. You won't find any advertising in Tales Up.",
        },
        social: {
            title: "Social",
            intro: "“Over here, you'll find other adventurers with whom you can embark on an exciting journey of storytelling!“",
            publicLobby:
                "1. Join public parties in the Lobby, even if you don't own the story.",
            friends: "2. Add friends and invite them to join your adventures.",
            ladder: "3. climb the ladder and become one of Tales Up's greatest adventurers",
            news: "4. check out the latest application news",
        },
        rewards: {
            title: "Rewards",
            intro: "“This is where you can watch your progress and collect the rewards you earn throughout your adventures.“",
            level: "1. Follow the progress of your quests and level up",
            mainQuest: "2. Unlock Gallery stories by gaining experience",
            avatar: "3. Get many unique items and avatars",
            titles: "4. Get the exclusive titles of each story by discovering all their successes",
            parrain: "5. Refer other players and earn unique rewards",
        },
    },
    mainQuest: {
        title: "The Gallery",
        subtitle: "Level up to unlock main quest episodes",
        subtitle2:
            "The Gallery episodes are unique adventures based on the history of the game.",
        unlocked: "Unlocked",
        unlockAtLevel: "Unlocked at level",
        storyTitles: [
            "The Gallery",
            "The Painter",
            "The Presence",
            "The Disappearance",
            "The Eclipse",
            "The Inheritance",
        ],
    },
    referral: {
        title: "Referral",
        subtitle:
            'Invite friends and receive rewards! Click on "Invite" or send them your player code directly. All your friends have to do is enter it when they register. Once registered, you\'ll both receive rewards here!',
        inviteeReward: "Invitee reward",
        referralRewards: "Referral rewards",
        referralReward: "Referral reward",
        invitee: "Invitee",
        refer: "Sponsor",
        noReferrals: "You have no invitees for the moment",
        referFriend: "Refer friend",
        joinMe: "Join me on Tales Up!",
        joinMeBoby:
            "Join me on Tales Up and unlock an exclusive cosmetic! Here's how to get started:",
        joinMeBoby2: "1. Go to talesup.io and start the adventure!",
        joinMeBoby3:
            "2. When you're asked to sign up, enter my sponsorship code: ",
        referralCode: "Referral code",
        dontHaveCode: "I don't have a referral code",
        codeDoesntExist: "This code does not exist",
        errorAddingReferral: "We were unable to add this player as a sponsor",
        addReferral: "If you have a referral code, enter it below!",
        friendsReferred: "Friends sponsored",
    },

    // ###################  FAQ & COOKIES ##############################

    cookiesBanner: {
        title: "Cookies? 🍪",
        audience: "Audience :",
        audienceSub:
            "Audience cookies allow us to collect information about player connection and behavior for statistical purposes.",
        firebase: "Firebase Analytics",
        decline: "Refuse",
        accept: "Accept",
        usage: "Usage:",
        usageSub:
            "Usage cookies allow us to keep track of your preferences, such as the language to be used or your current games.",
        all: "All",
        interest: "Legitimate interest",
        policy: "Learn more about our cookie policy",
        subtitle:
            "We use cookies to save your preferences, such as the language you prefer to use or the games you're playing, and to keep statistics on your visits to our site.",
        subtitle2:
            'We store your choice for 6 months. You can change your preferences once you\'ve logged in in "Menu > About > Manage my choices"',
        choose: "I choose",
        acceptAll: "Accept all",
        validate: "Validate",
        interestOnly: "Legitimate interest only",
    },
    purchaseHelp: {
        notReceived: "Didn't you receive your tickets?",
        notReceivedSub:
            "Normally, you receive your purchased tickets immediately. If the page displays 'Payment validated' and you didn't get a confirmation popup, you can try refreshing the page. If this doesn't solve the problem, you can contact us by pressing the 'Contact us' button at the bottom of this page (including a screenshot of the receipt you must have received by email). If the button doesn't work, send us an email at support@talesup.io (including the receipt as indicated above and specifying the email address linked to the Tales Up account with which you made your purchase.",
        validation: 'The page displays "Validation error"?',
        validationSub:
            "If the page displays \"Validation error\", this means that we have been unable to finalize your payment. You can try refreshing the page, and if that doesn't solve the problem, you can contact us by pressing the 'Contact us' button at the bottom of this page (including a screenshot of the receipt you should have received by email). If the button doesn't work, send us an email at support@talesup.io (including the receipt as indicated above and specifying the email address linked to the Tales Up account with which you made your purchase.",
        payment: 'The page displays "Payment error"?',
        paymentSub:
            "If the page displays \"Payment error\", this means that you have cancelled the current purchase or that the payment has been refused and we have been unable to finalize your payment. As the transaction failed, you should not be charged. If you still have a problem, you can contact us by clicking on the 'Contact us' button at the bottom of this page. If the button doesn't work, please send us an email to support@talesup.io explaining your problem",
    },
    faqList: [
        {
            title: "Account",
            articles: [
                {
                    title: "I lost my account",
                    sub: "If you signed in with an email address, you can start the recovery process on the login screen by selecting 'I already have an account' > 'I forgot my password'. If you registered using Google or Facebook, or no longer have access to your email address, send us an email with the following information: \n\n - Your player code (if you know it) \n - Your username (if you know it) \n - The email address you used (the address you used for google or facebook if you logged in using either)",
                    remark: "",
                },
                {
                    title: "Someone else is using my account",
                    sub: "If you need assistance with your account, please send us an email with the following information: \n\n - Your player code \n - Your username \n - The email address you used (the address you used for google or facebook if you logged in using either)",
                    remark: "Account sharing is strictly against our terms and conditions. We reserve the right to suspend any shared accounts and refuse service to their owners.",
                },
                {
                    title: "How can I guarantee the safety of my account",
                    sub: " - Use a secure password \n\n - Never share your account with anyone, and never play on other people's accounts. Doing so may lead to your account being permanently suspended, for more information, please read the terms and conditions. \n\n - Do not try to recover someone else's account, even for a friend, as this may be considered an attempt at 'phishing'. We have no way of differentiating between a friend that you asked for help and a person attempting to steal your account. People must contact support only for their own accounts.",
                    remark: "",
                },
                {
                    title: "Logging in with Google or Facebook",
                    sub: "You can register and login to Tales Up using your Google or Facebook accounts. We cannot however guarantee that these options will always be available. If such a case were to arise, we would of course warn you in advance and provide adequate replacement or transfer options.",
                    remark: "We do not store personal data other than in-game metrics, your email address, username, name and surname.",
                },
                {
                    title: "Requesting deletion of my personal data",
                    sub: 'It is entirely possible to request that we delete all the personal data that our game collects about you. \n\nTo do this you have to close and delete your game account permanently, including all purchases, progress paid or not, and other information using the "Contact us" option at the bottom of the screen.',
                    remark: "",
                },
                {
                    title: "Requesting a copy of my personal data",
                    sub: "We can provide you with a digital copy of all personal data we have recorded about you on request. \n\n Here are the steps to follow: \n\n 1. You must be the owner of the account for which you are making the request . \n 2. Send an email to support@talesup.io, via the 'Contact us' button, requesting a copy of the personal data we have stored for your account. Please remember to state your player code and email address in the request .",
                    remark: "We cannot send information about an account to an email address that is not linked to that account.",
                },
            ],
        },
        {
            title: "Purchases",
            articles: [
                {
                    title: "I did not receive my purchase on iOS",
                    sub: "Most of the time, purchased items are processed and granted immediately, sometimes this process takes a little longer. If this occurs, it simply means that your purchase has not yet been processed. There is no need to attempt to purchase the same item again, you will receive it shortly! \n\nIf you have waited over 24 hours, please contact Apple support. Apple handles all in game purchases.",
                    remark: "",
                },
                {
                    title: "I did not receive my purchase on Android",
                    sub: "If you attempted to make a purchase but your order was canceled, you will not be charged. \n\nHowever, Google Play Store may have temporarily reserved funds on your account, equal to your purchase. Don't worry, any reserved funds are automatically returned after a brief delay. \n\nGenerally speaking, purchases are canceled if the billing address and/or the name in your Google Wallet are different from those on your bank card. \n\nTo fix this, please contact your bank and verify your information, then log in to Google Play and check the payment methods section to make sure all of the information is correct.",
                    remark: "If after 24 hours you haven't received anything, please send a screenshot of your receipt to support@talesup.io \n\nThe transaction number (for example: GPA.1234-1234-1234-12345) at the bottom of the document must be visible on the screenshot.",
                },
            ],
        },
        {
            title: "Gameplay",
            articles: [
                {
                    title: "How to play?",
                    sub: "You want to jump into one of Tales Up's many adventures and don't know where to start? You've come to the right place. \n\nFirst things first, you have to choose a story and download it. Next, you have to choose a gamemode (see below for gamemodes).\n\n - If you choose 'tabletop' mode, you just need to enter your friends' names and press 'Let's go'.\n\n - If you choose 'online', everyone needs to download Tales Up, and create an account. Once that is done, you can create a lobby. You will be given a room code, all you have to do is share it with the others. They will have to press 'join a game' from their library and enter the code. Once everyone has joined and downloaded the story, you can start.",
                    remark: "In 'online' mode, only the host (the person who created the lobby) needs to own the story to be able to play it. You can therefore share all of the stories you purchase with your friends.",
                },
                {
                    title: "Gamemodes",
                    sub: "As explained above, Tales Up offers two different gamemodes: \n\n - The 'tabletop' mode: Just like any board game, your phone will act as the board here. The telephone gets passed around between players, you get to read the scenes out loud, share the pictures, and discuss (or not) every choice.\n\n - The 'online' mode : everyone has the text directly on their own device, and you vote individually (and anonymously) for decisions. In some situations, only one player may be concerned by a choice and therefore only they will vote.",
                    remark: "If a tie occurs in online mode then a decision will be picked at random between the tied possibilities.",
                },
                {
                    title: "Standard choices",
                    sub: "The most basic situation: you are faced with a choice and you have to agree (or vote in online mode) on the decision to make",
                    remark: "",
                },
                {
                    title: "Choosing players",
                    sub: "These choices involve selecting a player to perform a specific action or acquire an item. Be careful in your choices because based on previous actions and the state of a player, your options may differ. Additionally, this can also have hefty consequences on the rest of the story. Choose carefully!",
                    remark: "",
                },
                {
                    title: "Typed answers",
                    sub: "Some situations may require you to type in a code or password. You will have to press the 'answer' button then type in the answer that you believe to be correct, then confirm using the appropriate key on your keyboard, which may vary based on the device.",
                    remark: "In some cases there are multiple correct answers, and as long as yours is among them, nothing to worry about :)",
                },
                {
                    title: "Switching players",
                    sub: "You will often find occurrences of 'The spotlight is on ...', in 'tabletop' mode, you will have to pass the device to the person in question, and let them make decisions. In 'online' mode, only that player will be able to vote until the end of the section.",
                    remark: "",
                },
                {
                    title: "Secret sections",
                    sub: "Some stories contain secret sections. These sections only concern the player that they mention. They should keep any and all information they are given to themselves. Of course, it's up to you to enforce the rule (or not) :)  ",
                    remark: "In 'online' mode, secret sections are only displayed for the concerned player.",
                },
            ],
        },
        {
            title: "Troubleshooting",
            articles: [
                {
                    title: "Why am I constantly getting connexion lost alerts",
                    sub: "For a fluid experience, you should connect to a reliable network and have a strong signal on your device. Full wifi bars or mobile data coverage are insufficient to guarantee a stable connection on their own because local networks can easily become overloaded. This is particularly true when you are in a moving vehicle or underground public transport. \n\nAs with any other online service, we recommend that you play while using Wifi from a reliable service provider or with a bare minimum of a solid 3G/4G connection.",
                    remark: "",
                },
                {
                    title: "Technical issues",
                    sub: "If the game crashes, reinstalling it fresh can fix the issue. However this should only be done as a final measure and if the game crashes repeatedly. If the crash occurs during a story this could be caused by a technical bug on our end. In any case, if the issue is persistent, please don't hesitate to contact support (if the crash occurs in a story, which story, which chapter if it is in chapters, and part of the text or general context of the moment to help us locate the issue effectively), via the contact button, it is important to us that we provide you with the best possible experience at all times",
                    remark: "",
                },
                {
                    title: "Recommended configuration",
                    sub: "For android : OS 5 or later, 0.5 GO of RAM minimum (1 GO or more recommended), a minimum screen resolution of 800x400. For iOS : iOS 10 or later, iPhone 5 or more recent, 1 GB of RAM, and a minimum screen resolution of 640x960 (higher resolutions are recommended). \n\nThese specifications are not always enough to fully enjoy all the application has to offer. Some devices may be more appropriate for this application than others.",
                    remark: "",
                },
                {
                    title: "Comments",
                    sub: "We appreciate all comments, suggestions and feedback about Tales Up. To share your ideas on how best to improve the experience, there is no better place than our official pages on social media. \n\n If you would like to join the beta testing team, please join our discord (links can be found in 'Socials'), you will find further instructions on the procedure there.",
                    remark: "",
                },
                {
                    title: " ",
                    sub: " ",
                    remark: "",
                },
            ],
        },
    ],
    cookie: {
        gestion: "Cookies",
        accept: "Accept",
        acceptAll: "Accept all",
        customize: "Customize",
        explanation:
            "Some features of this app use third party features that may require trackers. These services are very important to use because they help improve the app and identify potential issues. You can change your decision at any point from the menu > About > Manage my choices. If you want to know more please check out ",
        youChoose: "Your choice",
        privacyPolicy: "Privacy policy",
        save: "Save",
        cookieExplanation:
            "These are the optional trackers. They are, however, still a great help to us. For more information on how our app uses cookies and trackers please read our ",
        cookiePolicy: "Cookie policy",
    },

    cookiesList: [
        {
            name: "Facebook",
            purpose: "Audience Measurement & Attribution",
        },
        {
            name: "Google Firebase Analytics",
            purpose: "Bug reports, Audience Measurement & Attribution",
        },
    ],
    cookiesInfo: [
        {
            name: "1. scope of application of the Charter",
            text: 'This Charter is intended to apply to the following media: The Tales Up mobile application available on the Apple App Store, the Google Play Store and the website talesup.io (hereinafter "Application")',
        },
        {
            name: "2. What are cookies and other trackers?",
            text: "Internal or partner tools are installed on the Application (hereinafter \"Tracking Tool\") to access and collect data on your device (hereinafter \"Identifiers\"). The data that may be collected is as follows:\nThe user's device ID;The version of the Application installed on the user's device;The model of the user's device; The version of the operating system (OS) of the user's device;\nUser's device battery level; User's device language setting; User's device ad ID (IDFA/GAID); User's device push ID; User's phone carrier; User's country, and continent; User's IP address.\nTracking Tools shall be referred to, individually or together, as \"Trackers\" below.",
        },
        {
            name: "3. Why does Periple Studio use cookies and Trackers?",
            text: "Periple Studio uses Trackers on its Application for the purposes listed below.For these purposes, Periple Studio is likely to allow third-party partners to deposit cookies or access Identifiers and cookies on the hard drive of your terminal when you use our Application.Your agreement is a priority for Periple Studio, so we ask for your consent before any deposit of cookies except for those responding to technical needs, these being strictly necessary for navigation on the site. Similarly, your consent is required for the use of Trackers on the Application and the collection of Identifiers by the Tracking Tools. Your consent is not required unless the Trackers are strictly necessary for the operation or security of the Application.There are no cookies placed by mobile applications. However, the Application accesses and collects your device's unique Identifiers in order to recognize it from one visit to the next.\n\n,Internal and partner tools and Trackers have been installed on the Application in order to access and collect the Identifiers.These Trackers allow Periple Studio to:\n-ensure the proper functioning of the Application-operate certain features-if you have consented, use them for advertising or analysis.\nTechnical needs:\nWhen you consult the Application, so-called security Trackers collect and process data from your device. They can be used for authentication or security purposes. They are required to enable certain features of the Application and to ensure its security. Functional Trackers are also used to enhance and optimize your experience on the Application, or are required to use certain features. \n\nSecurity and functional Tracking Tools are strictly necessary for the provision of Tales Up services on the Application, so you may not refuse the collection of Identifiers and the use of security or functional Trackers.\nSome Trackers are specific to the Application, where applicable this is indicated in their purpose below. \n\nFacebook Login: Facebook, Functional, Allow registration via Facebook-Google Firebase, Google, Functional, Send push notifications to users-Sign in with Google: Google, Functional, Allow registration via Google Sign-in-Analytical needs:Periple Studio uses audience measurement Trackers to obtain information on the user's path, to analyze traffic on the Application and for audience measurement purposes. This allows Periple Studio to improve the Application according to the requests and needs of users. Some Trackers are specific to the Application or, if applicable, this is indicated in their purpose below. Your consent is requested for the collection of Identifiers and the use of Trackers for analytical purposes",
        },
        {
            name: "4. How to manage your cookies and the use of your Credentials",
            text: 'When you register on the Application, a consent screen for Trackers offers you to accept, refuse or parameterize the use of Trackers that are not essential to the stable operation of the Application.\nIn the event of a new connection on the Application after a disconnection, the screen will be displayed again and will offer you to accept, refuse or parameterize the use of Trackers. \n\nThe consent you provide for the use of analytics and advertising Trackers can be withdrawn at any time. From the Application, simply click on the "Menu > About > Manage My Choices" link. \n\nWith the exception of the Trackers used for audience measurement and advertising purposes, all the Trackers of the Application listed above are essential to the stable functioning and operation of the Application Services to which you have subscribed. \n\nFor Trackers used for advertising purposes, you may also configure your device to refuse personalized advertising:\nFor Apple/ iOS:\nGo to Settings > Privacy > Advertising:\n-Enable "Limited Ad Tracking"\nFor Android/Google Play Store:\nGo to Settings > Account or Sync or Google (depending on your device) > Privacy or Advertising or Ads (depending on your device)\n-Enable "Disable ad personalization."',
        },
        {
            name: "5. Contact",
            text: "If you have any questions concerning the present Charter or a complaint about cookies and tracking tools, you can contact us:\n\n-Email our contact email address: support@talesup.io \n-Email our data protection referent: referent.donnees@talesup.io\n-Post a letter to the following postal address: \nFor the attention of the data protection referent \nPériple Studio\n7 rue Viollet-le-Duc, Clermont-Ferrand\nFrance\nFor your information, you will find below the information concerning the company in charge of applying this Charter: \nSAS Périple Studio registered under number 894 383 553 at the RCS of Clermont-Ferrand, whose head office is located at 7 rue Viollet-le-Duc, Clermont-Ferrand France and represented by its president, Mr Victor Jaffeux. \n\nFinally, don't forget to consult our Privacy Policy",
        },
    ],
    whoWeAreTitle: "Who are we?",
    whoWeAre: [
        {
            type: "title",
            content: "About us :",
        },
        {
            type: "text",
            content:
                "We are a French video game and mobile application development studio. For the moment, we are working exclusively on Tales Up! \n\nToday, there are about ten of us, but at the beginning, Tales Up was a much less ambitious student project. Our faith in the game led us to throw ourselves into it once we had finished our studies. Since then, we've been trying to make a living out of it :)",
        },
        { type: "image", content: "../../assets/images/team.jpg" },
        {
            type: "title",
            content: "Our values :",
        },
        {
            type: "text",
            content:
                "We want to create a game that makes role-playing much more accessible. Our goal is to turn the phone into a tool to bring people together and connect, rather than isolate them.\n\nWe create stories that speak to us, in the hope that they will speak to others afterwards, and we aim to create increasingly unique and immersive experiences.\n\nWe also want to create something that can be played by everyone, with a business model that doesn't rely on frustration or intrusive advertising.",
        },
        { type: "image", content: "../../assets/images/promo.jpg" },
        {
            type: "title",
            content: "Our objectives :",
        },
        {
            type: "text",
            content:
                "We hope first of all to make Tales Up profitable and to continue to create new stories, series, sagas, while always increasing the overall level of quality.\n\nWe also hope to create new games and new innovative applications, always with the idea of creating a link between people.",
        },
    ],
};
